import {IChangeHolder} from "./i-gengine-data-holder";

export class GengineProxyFactory {
  constructor(private holder: IChangeHolder) {
  }

  makeProxy<T>(data: T, key= '', parent?: any): T {
    const type =typeof data;
    switch(type) {
      case 'object':
        if (!data) {
          return data;
        }
        if(data['__isGengineProxy']) {
          if(key.startsWith('__')) {
            console.error(new Error(`bad key ${key}`));
          }
          data['__key'] = key;
          data['__parent'] = parent;
          return data;
        }
        return this.makeObjectProxy(data, key, parent);
      default:
        return data;
    }
  }

  toJson(proxy) {
    if(typeof proxy !== 'object' || !proxy)  {
      return proxy;
    }
    const array = Array.isArray(proxy);
    if(array) {
      const res = [];
      for(let value of proxy) {
        if(typeof value === 'object') {
          value = this.toJson(value)
        }
        res.push(value);
      }
      return res;
    } else {
      const res = {};
      for(const key of Object.keys(proxy)) {
        if(key.startsWith('__')) { continue; }
        let value = proxy[key];
        if(typeof value === 'object') {
          value = this.toJson(value)
        }
        res[key] = value;
      }
      return res;
    }
  }

  path(target: any, depth= 0) {
    if(depth > 20) {
      console.error(new Error('too deep'));
      return '';
    }
    return target.__parent
      ? this.path(target.__parent, depth +1) + "/" + target.__key
      : target.__key;
  }

  addChange(target, key, value) {
    this.holder.addChange({path: `${this.path(target)}/${String(key)}`, value: this.toJson(value)})
  }

  makeObjectProxy<T>(data: T, key= '', parent?: any): T {
    const factory = this;
    const set = (target, key, value): boolean => {
      if (!String(key).startsWith('__') && !target['__hold']) {
        if(target[key] !== value) {
          factory.addChange(target, key, value);
        }
        if (typeof value === 'object' && value) {
          value = this.makeProxy(value, String(key), target);
        }
      }
      target[key] = value;
      return true;
    };

    const get = (target, key): any => {
      if(key == "__isGengineProxy") {
        return true;
      }
      return target[key];
    };

    const enumerate = (target) => {
      return Object.keys(target).filter(k => !k.startsWith('__'));
    };

    const dataKeys = Object.keys(data).filter(k => !k.startsWith("__"));
    data['__parent'] = parent;
    data['__key'] = key;

    let result;
    if (Array.isArray(data)) {
      result = new Proxy(data, {
        set, enumerate, ownKeys: enumerate,
        get(target, key) {
          const push = (...args: any[]): number => {
            target.__hold = true;
            factory.addChange(target,+'push', args);
            const res = data.push(...factory.mapTarget(args, target.length, target));
            target.__hold = false;
            return res;
          };
          if(key == 'push') {
            return push;
          }
          if(key == 'splice') {
            return (start, ...args) => {
              target.__hold = true;
              factory.addChange(target, 'splice',[start, ...args]);
              for (let i = 1; i < args.length; i++) {
                args[i] = factory.makeProxy(args[i], i - 1 + start, target);
              }
              const added = Math.max(0, args.length - 1);
              const result = factory.toJson(target.splice(start, ...args) as any);
              for (let i = start + added; i < target.length; i++) {
                if (typeof target[i] === 'object' && target[i]) {
                  console.log(`splice change path ${factory.path(target[i])} to ${factory.path(target)}/${i}`);
                  target[i].__key = i;
                }
              }
              target.__hold = false;
              return result;
            }
          }
          return get(target, key);
        }
      }) as any as T;
    } else {
      result = new Proxy(data as any as object, { set , get, enumerate, ownKeys: enumerate }) as any as T;
    }
    for (let dataKey of dataKeys) {
      data[dataKey] = this.makeProxy(data[dataKey], dataKey, result);
    }
    return result;
  }

  mapTarget(values: any[], start: number, target) {
    return values.map((v,i) => this.makeProxy(v, `${start+i}`, target))
  }
}
